/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './Cms/**/*.blade.php',
    './public/js/app.min.js',
    './public/**/*.html',
    './resources/**/*.blade.php',
    './storage/framework/views/*.php',
  ],
  theme: {
    extend: {
      fontFamily: {
        'sans': ['Sigmund', 'Helvetica', 'Arial', 'sans-serif'],
        'serif': 'Times New Roman',
      },
      colors: {
        default: '#000000',
        grey: '#EBEBEB',
        green: {
          DEFAULT: '#628D76',
          500: '#CAEBDA',
        },
      },
      spacing: {
        18: '4.5rem',
        'gap': 'var(--gap)',
        'gap/2' : 'calc(var(--gap) / 2)',
        'gap-2' : 'calc(var(--gap) * 2)',
        'gap-3' : 'calc(var(--gap) * 3)',

        'vs': 'var(--vspace)',
        'vs/2' : 'calc(var(--vspace) / 2)',
        'vs-2' : 'calc(var(--vspace) * 2)',
        'vs-3' : 'calc(var(--vspace) * 3)',
        
        'ss': 'var(--sspace)',
        'ss/2' : 'calc(var(--sspace) / 2)',
        'ss-2' : 'calc(var(--sspace) * 2)', 
        'ss-3' : 'calc(var(--sspace) * 3)',
      },
      opacity: {
        50: '0.5',
      },
      zIndex: {
        1000: 1000,
      },
    },
    screens: {
      'sm': '600px',
      'md': '768px',
      'lg': '1024px',
      'xl': '1280px',
      '2xl': '1500px',
      '3xl': '1920px',
    }
  },
  plugins: [
    require('@tailwindcss/typography'),
  ],
}
